import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { CalendarIcon } from "../../icons";

const SingleDateWithoutArrow = () => {
  const dateInputRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(moment()); // default = today

  useEffect(() => {
    const $input = $(dateInputRef.current);
    const start = moment(selectedDate); // freeze initial date

    $input.daterangepicker(
      {
        singleDatePicker: true,
        showDropdowns: true,
        minYear: 1901,
        maxYear: parseInt(moment().format("YYYY"), 10),
        opens: "auto",
        drops: "auto",
        autoApply: true,
        autoUpdateInput: true,
        startDate: start,
      },
      function (start) {
        setSelectedDate(start); // update state when calendar is used
      }
    );

    // Set initial value manually
    $input.val(start.format("MM/DD/YYYY"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateDate = (newDate) => {
    setSelectedDate(newDate);
    const $input = $(dateInputRef.current);
    $input.val(newDate.format("MM/DD/YYYY"));
    $input.data("daterangepicker").setStartDate(newDate);
  };

  const goToPreviousdate = () => {
    const newDate = moment(selectedDate).subtract(1, "days");
    updateDate(newDate);
  };

  const goToNextdate = () => {
    const newDate = moment(selectedDate).add(1, "days");
    updateDate(newDate);
  };

  const openCalendar = () => {
    $(dateInputRef.current).trigger("click");
  };

  return (
    // <div className="d-flex align-items-center space-x-2 gap-1">
    //   <button
    //     onClick={goToPreviousdate}
    //     style={{
    //       background: "#fff",
    //       padding: "6px 15px",
    //       width: "50px",
    //       height: "38px",
    //       border: "1px solid rgba(229, 232, 235, 1)",
    //       borderRadius: "20px",
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "center",
    //     }}
    //   >
    //     <ArrowBackIosIcon sx={{ width: "15px", height: "15px" }} />
    //   </button>

    //   <div className="form-group position-relative">
    //     <input
    //       style={{
    //         background: "#fff",
    //         display: "flex",
    //         fontSize: "14px",
    //         padding: "6px 15px",
    //         alignItems: "center",
    //         justifyContent: "center",
    //         width: "257px",
    //         border: "1px solid rgba(229, 232, 235, 1)",
    //         borderRadius: "20px",
    //         height: "38px",
    //       }}
    //       type="text"
    //       ref={dateInputRef}
    //       className="form-control pe-5"
    //       placeholder="Select date"
    //       readOnly
    //     />
    //     <span
    //       onClick={openCalendar}
    //       style={{
    //         position: "absolute",
    //         right: "0px",
    //         top: "50%",
    //         cursor: "pointer",
    //         color: "#555",
    //       }}
    //     >
    //       <CalendarIcon
    //         style={{
    //           position: "absolute",
    //           right: "13px",
    //           top: "50%",
    //           transform: "translateY(-50%)",
    //         }}
    //       />
    //     </span>
    //   </div>

    //   <button
    //     onClick={goToNextdate}
    //     style={{
    //       background: "#fff",
    //       padding: "6px 15px",
    //       width: "50px",
    //       height: "38px",
    //       border: "1px solid rgba(229, 232, 235, 1)",
    //       borderRadius: "20px",
    //       display: "flex",
    //       alignItems: "center",
    //       justifyContent: "center",
    //     }}
    //   >
    //     <ArrowForwardIosIcon sx={{ width: "15px", height: "15px" }} />
    //   </button>
    // </div>



    <div className="">
  <div className="form-group position-relative">
    <input
      style={{
        background: "#fff",
        display: "flex",
        fontSize: "14px",
        padding: "6px 15px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        height: "40px",
      }}
      type="text"
      ref={dateInputRef}
      className="form-control pe-5"
      placeholder="Select date"
      readOnly
    />
    <span
      onClick={openCalendar}
      style={{
        position: "absolute",
        right: "0px",
        top: "50%",
        cursor: "pointer",
        color: "#555",
      }}
    >
      <CalendarIcon
        style={{
          position: "absolute",
          right: "13px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      />
    </span>
  </div>
</div>

  );
};

export default SingleDateWithoutArrow;
